var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "header-search__form",
      class: { "p-0": _vm.$ceres.isShopBuilder },
    },
    [
      _c(
        "div",
        { staticClass: "input-group" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchString,
                expression: "searchString",
              },
            ],
            ref: "searchInput",
            staticClass: "header-search__input form-control",
            attrs: {
              type: "search",
              autofocus: _vm.isShopBuilder,
              placeholder: _vm.$translate(
                "Ceres::Template.headerSearchPlaceholder"
              ),
              "aria-label": _vm.$translate("Ceres::Template.headerSearchTerm"),
            },
            domProps: { value: _vm.searchString },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.searchString = $event.target.value
                },
                function ($event) {
                  return _vm.onValueChanged($event.target.value)
                },
              ],
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.search()
              },
              focus: function ($event) {
                _vm.isSearchFocused = true
              },
              blur: function ($event) {
                return _vm.onBlurSearchField($event)
              },
            },
          }),
          _vm._v(" "),
          _vm._t("search-button", function () {
            return [
              _c("div", { staticClass: "input-group-append" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn header-search__btn",
                    attrs: {
                      type: "submit",
                      "aria-label": _vm.$translate(
                        "Ceres::Template.headerSearch"
                      ),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.search()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "header__svg",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "20",
                          height: "20",
                        },
                      },
                      [
                        _c("use", {
                          attrs: {
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            "xlink:href": "#svg-search-icon",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          }),
          _vm._v(" "),
          _vm.isSearchFocused
            ? [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (_vm.searchString.length >= _vm.searchMinLength &&
                            _vm.hasInitialInput) ||
                          _vm.$ceres.isShopBuilder,
                        expression:
                          "(searchString.length >= searchMinLength && hasInitialInput) || $ceres.isShopBuilder",
                      },
                    ],
                  },
                  [
                    _vm._t("autocomplete-suggestions", function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "autocomplete-suggestions" },
                          [
                            _c("search-suggestion-item", {
                              attrs: {
                                "show-images": _vm.showItemImages,
                                "suggestion-type": "item",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }